import * as ResultsInventionDisclosure from './resultsInventionDisclosure.js';
export default ResultsInventionDisclosure;
